import axios from "./axios";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import { createApp } from "vue";


//video js
import 'video.js/dist/video-js.css'
import VueVideoPlayer from "vue-video-player";

//helpers
import helpers from './helpers'

//plugins
import plugins from './plugins'
import toast from './plugins/toastification'
import datePicker from './plugins/date-picker'

import Vue3Tour from 'vue3-tour'
import 'vue3-tour/dist/vue3-tour.css'

//charts for graphs
import VueApexCharts from "vue3-apexcharts";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

import "@/assets/css/style.scss";
import "@/assets/css/mobile.css"
import "@/assets/css/fontawesome/css/fontawesome.css"
import "@/assets/css/fontawesome/css/solid.css"


import "@/assets/css/all.min.css";
import "@/assets/css/app.css";
import "@/assets/css/responsive.css";

import { vfmPlugin } from 'vue-final-modal'
import VueNextSelect from 'vue-next-select'
import 'vue-next-select/dist/index.min.css'

export const app = createApp(App)

app.component('vue-select', VueNextSelect)
app.use(vfmPlugin({
  key: '$vfm',
  componentName: 'VueFinalModal',
  dynamicContainerName: 'ModalsContainer'
}))

//vue3 grid layout
import { GridLayout, GridItem } from 'vue3-grid-layout-next';
app.component('GridLayout', GridLayout);
app.component('GridItem', GridItem);

app.use(store)
app.use(router)
app.use(VueApexCharts)
app.use(VueVideoPlayer)
app.use(Vue3Tour)
app.use(helpers)
app.use(plugins)
app.use(toast)
app.use(datePicker)
app.use(axios)

app.mount("#app")